"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistOrLoginForH5Request = void 0;
var RegistOrLoginForH5Request = /** @class */ (function () {
    function RegistOrLoginForH5Request() {
    }
    return RegistOrLoginForH5Request;
}());
exports.RegistOrLoginForH5Request = RegistOrLoginForH5Request;
;
//# sourceMappingURL=registOrLoginForH5.request.js.map